import React from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./about.module.scss"

import Layout from "../../components/Layout/Layout"
import SEO from "../../components/seo"
import SecondTitle from "../../components/UI/SecondTitle/SecondTitle"
import StorySlider from "../../components/Sections/About/StorySlider/StorySlider"
import ExpertsList from "../../components/Sections/About/ExpertsList/ExpertsList"
import Swipe from "../../components/UI/Swipe"


const About: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	return (
		<Layout location={location}>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "about.seo.description" })}
				title={intl.formatMessage({ id: "about.seo.title" })}
				pathname={location.pathname}
			/>
			<SecondTitle desktopImage="/images/pages-heading/professional.png" mobileImage="/images/pages-heading/m-professional.png" title={intl.formatMessage({ id: "about.title" })} position="right center" />
			<section className={styles.about}>
				<div className={styles.container}>
					<div className={styles.intro}>
						<h2>{intl.formatMessage({ id: "about.banner.title" })}</h2>
						<p>{intl.formatMessage({ id: "about.banner.text1" })}</p>
						<p>
							{intl.formatMessage({ id: "about.banner.text2" })}
							{intl.formatMessage({ id: "about.banner.text3" })}
						</p>
						<p>{intl.formatMessage({ id: "about.banner.text4" })}</p>
					</div>
				</div>
			</section>
			<section className={styles.story}>
				<div className={styles.container}>
					<div className={styles.storyTitleBlock}>
						<h2 className={styles.storyTitle}>{intl.formatMessage({ id: "story.title" })}</h2>
						<Swipe />
					</div>
					<StorySlider />
				</div>
			</section>
			<section className={styles.experts}>
				<div className={styles.container}>
					<h2>{intl.formatMessage({ id: "about.title-experts" })}</h2>
					<ExpertsList />
				</div>
			</section>
		</Layout>
	)
}

export default About;
